import { useState, useMemo } from 'react'
import { createPortal } from 'react-dom'
import closeIcon from '../../../../../_metronic/images/closeSymbol.svg'
import * as Yup from 'yup'
import { Col, Modal, Row } from 'react-bootstrap'
import EmailReport from './EmailReport'
import { useFormik } from 'formik'
import { useLazyQuery, useMutation } from '@apollo/client'
import { CREATE_REPORT_SETTINGS, SEND_ALERTS_TO_EMAIL, GETCLIENTFEATUREFLAGS } from '../../../../../utils/GraphQLAPI'
import { getToken, alert } from '../../../../../utils/helper'
import ScheduleRecurring from './ScheduleRecurring'
import momentTimezone from 'moment-timezone'
import TextField from '../../../../sharedComponent/TextField/TextField'
import Dropdown from '../../../../sharedComponent/Dropdown/Dropdown'
import './TimePicker.css'


type Props = {
  show: boolean
  handleClose: () => void
  filterOptions: any
  dateFilterType: string
}

const modalsRoot = document.getElementById('root-modals') || document.body

const enrollSchema = Yup.object().shape({
  emailId: Yup.string().required('Email is required'),
  subject: Yup.string().required('Subject is required'),
  daysForPhone: Yup.number()
    .typeError('No. of days must be a number')
    .positive('No. of days must be a positive number'),
  daysForEmail: Yup.number()
    .typeError('No. of days must be a number')
    .positive('No. of days must be a positive number'),
  DBtwAgentAndService: Yup.number()
    .typeError('Distance must be a number')
    .positive('Distance must be a positive number'),
  DBtwAgentAndCustomer: Yup.number()
    .typeError('Distance must be a number')
    .positive('Distance must be a positive number'),
  Enrollment: Yup.number()
    .typeError('No. of Minutes must be a number')
    .positive('No. of Minutes must be a positive number'),
  ExceededEnrollment: Yup.number()
    .typeError('No. of Enrollments must be a number')
    .positive('No. of Enrollments must be a positive number'),
  emailScore: Yup.number()
    .nullable()
    .min(1, 'Minimum value is 1')
    .max(100, 'Maximum value is 100')
})

const defaultConfig = {
  selectedTime: '12:00 AM',
  currentScreen: 'QUICKDOWNLOAD',
  scheduleType: 'DAILY',
  selectedDay: 'MONDAY',
  selectedDate: '1',
  fileFormat: 'EXCEL',
  isCheckAll: false,
}

const AlertReportModaal = ({ show, handleClose, dateFilterType }: Props) => {
  const [isCheckAll, setIsCheckAll] = useState<any>(false)
  const [loading, setLoading] = useState(false)
  const [showEmailModal, setShowEmailModal] = useState(false)
  const [currentScreen, setCurrentScreen] = useState(defaultConfig.currentScreen)
  const [scheduleType, setScheduleType] = useState(defaultConfig.scheduleType)
  const [selectedDay, setSelectedDay] = useState(defaultConfig.selectedDay)
  const [selectedDate, setSelectedDate] = useState('1')
  const [selectedTime, setSelectedTime] = useState<any>(defaultConfig.selectedTime)

  const emailOptions = [
    { id: 'Valid', value: 'Valid Email' },
    { id: 'Risky', value: 'Risky Email' },
    { id: 'Invalid', value: 'Invalid Email' },
  ]
  const [getClientFeatureflags, { data: featureFlags }] = useLazyQuery(GETCLIENTFEATUREFLAGS, {
    fetchPolicy: 'network-only',
  })

  const [sendEmailReport] = useLazyQuery(SEND_ALERTS_TO_EMAIL, {
    onCompleted: (data) => {
      alert('Alerts Report sent successfully', 'success')
    },
    onError: (data) => {
      alert(data.message, 'error')
    },
  })
  const handleBackScreen = () => {
    setCurrentScreen('QUICKDOWNLOAD')
  }
  const handleModalClose = () => {
    handleClose()

  }
  const integerFields = [
    'DBtwAgentAndService',
    'DBtwAgentAndCustomer',
    'daysForPhone',
    'daysForEmail',
    'Enrollment',
    'ExceededEnrollment',
    'emailScore',
    'emailRiskCategory',
  ]
  const formik = useFormik({
    initialValues: {
      emailId: '',
      subject: '',
      reportName: '',
      DBtwAgentAndService: '',
      DBtwAgentAndCustomer: '',
      daysForPhone: '',
      daysForEmail: '',
      Enrollment: '',
      ExceededEnrollment: '',
      emailScore: null,
      emailRiskCategoryId: '',
      emailIds: ''
    },
    validateOnMount: true,
    validationSchema: enrollSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      const emailIds = values.emailId.split(',')
      const regex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      const regexResult = emailIds.map((emailId: string) => regex.test(emailId.trim()))
      if (regexResult.some((result) => result === false)) {
        alert('Invalid Email Ids', 'error')
      } else {
        sendEmailReport({
          variables: {
            emailIds,
            subject: values.subject,
            input: {
              reportTimeZone: momentTimezone.tz.guess(),
              minDistanceBtwAgentAndCustomer: values.DBtwAgentAndCustomer
                ? parseFloat(values.DBtwAgentAndCustomer)
                : null,
              minDistanceBtwAgentAndServiceAddress: values.DBtwAgentAndService
                ? parseFloat(values.DBtwAgentAndService)
                : null,
              noOfDaysPhoneRepeated: values.daysForPhone ? parseInt(values.daysForPhone, 10) : null,
              noOfDaysMailRepeated: values.daysForEmail ? parseInt(values.daysForEmail, 10) : null,
              enrollmentsByAgentInMinutes: values.Enrollment
                ? parseInt(values.Enrollment, 10)
                : null,
              maximumEnrollmentOfAgentInADay: values.ExceededEnrollment
                ? parseInt(values.ExceededEnrollment, 10)
                : null,
              emailScore: values.emailScore ? values?.emailScore : null,
              emailVerdict: values.emailRiskCategoryId ? values.emailRiskCategoryId : null,
            },
          },
        })
        handleModalClose()
      }
    },
  })

  useMemo(() => {
    if (show) {
      getClientFeatureflags()
      setCurrentScreen(defaultConfig.currentScreen)
      setSelectedDay(defaultConfig.selectedDay)
      isCheckAll && setIsCheckAll(false)
      formik.setValues({
        emailId: '',
        subject: '',
        reportName: '',
        DBtwAgentAndService: '',
        DBtwAgentAndCustomer: '',
        daysForPhone: '',
        daysForEmail: '',
        Enrollment: '',
        ExceededEnrollment: '',
        emailScore: null,
        emailRiskCategoryId: '',
        emailIds: ''
      })
      formik.setTouched({})
      setSelectedTime(defaultConfig.selectedTime)
    }
  }, [show])// eslint-disable-line react-hooks/exhaustive-deps

  const [scheduleReport] = useMutation(CREATE_REPORT_SETTINGS, {
    onCompleted: () => {
      alert('Scheduled alerts report successfully', 'success')
      handleModalClose()
    },
    onError: (err) => {
      alert(err.message, 'error')
    },
  })
  const handleSelectedItem = (e: any, name: any) => {
    formik.setFieldValue(name, e.label)
    formik.setFieldValue(`${name}Id`, e.value)
  }
  const handleScheduleApi = () => {
    const emailIdsValue: any = {}
    const emailInput = formik.values.emailId?.trim();
    if (emailInput) {
      const emailIds = emailInput.split(',').map((email) => email.trim());
      const regex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const invalidEmails = emailIds.filter((emailId) => !regex.test(emailId));
      if (invalidEmails.length > 0) {
        alert('Invalid Email Ids', 'error')
        return;
      }
      emailIdsValue['emailIds'] = emailIds;
    } else {
      emailIdsValue['emailIds'] = [];
    }
    scheduleReport({
      variables: {
        createReportSettingsInput: {
          reportFilters: {
            reportTimeZone: momentTimezone.tz.guess(),
            minDistanceBtwAgentAndCustomer: formik.values.DBtwAgentAndCustomer
              ? parseFloat(formik.values.DBtwAgentAndCustomer)
              : null,
            minDistanceBtwAgentAndServiceAddress: formik.values.DBtwAgentAndService
              ? parseFloat(formik.values.DBtwAgentAndService)
              : null,
            noOfDaysPhoneRepeated: formik.values.daysForPhone
              ? parseInt(formik.values.daysForPhone, 10)
              : null,
            noOfDaysMailRepeated: formik.values.daysForEmail
              ? parseInt(formik.values.daysForEmail, 10)
              : null,
            enrollmentsByAgentInMinutes: formik.values.Enrollment
              ? parseInt(formik.values.Enrollment, 10)
              : null,
            maximumEnrollmentOfAgentInADay: formik.values.ExceededEnrollment
              ? parseInt(formik.values.ExceededEnrollment, 10)
              : null,
            emailIds: emailIdsValue['emailIds'],
          },
          emailScore: formik.values.emailScore ? formik.values?.emailScore : null,
          emailVerdict: formik.values.emailRiskCategoryId ? formik.values.emailRiskCategoryId : null,
          reportName: formik.values.reportName,
          reportFor: 'ALERT',
          reportFormat: 'EXCEL',
          reportTimeZone: 'ET',
          reportTime: selectedTime,
          reportType: dateFilterType?.toUpperCase()?.replaceAll(' ', '_'),
          reportFrequency: scheduleType,
        },
      },
    })
  }
  const handleOnChange = (e: any, name: string) => {
    formik.setFieldValue(name, e.target.value)
  }

  const gettingEmailId = () => {
    handleModalClose()
    setShowEmailModal(true)
  }

  const sendEmail = () => {
    handleRestAPIDownload(
      `${process.env.REACT_APP_BASE_URL}downloads/alertReports`,
      'QUICK_DOWNLOAD'
    )
  }

  const handleRestAPIDownload = async (downloadURL: string, mode: string) => {
    setLoading(true);
    try {
      const TOKEN = await getToken();
      const emailIdsValue: any = {};
      const emailInput = formik.values.emailIds?.trim();

      if (emailInput) {
        const emailIds = emailInput.split(',').map((email) => email.trim());

        const regex =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        const invalidEmails = emailIds.filter((emailId) => !regex.test(emailId));

        if (invalidEmails.length > 0) {
          alert('Invalid Email Ids', 'error');
          return; // finally will still run
        }
        emailIdsValue['emailIds'] = emailIds;
      } else {
        emailIdsValue['emailIds'] = [];
      }
      const res = await fetch(downloadURL, {
        method: 'POST',
        headers: new Headers({
          Authorization: `Bearer ${TOKEN}`,
          'Content-Type': 'application/json',
        }),
        body: JSON.stringify({
          reportTimeZone: momentTimezone.tz.guess(),
          minDistanceBtwAgentAndCustomer: formik.values.DBtwAgentAndCustomer
            ? parseFloat(formik.values.DBtwAgentAndCustomer)
            : null,
          minDistanceBtwAgentAndServiceAddress: formik.values.DBtwAgentAndService
            ? parseFloat(formik.values.DBtwAgentAndService)
            : null,
          noOfDaysPhoneRepeated: formik.values.daysForPhone
            ? parseInt(formik.values.daysForPhone, 10)
            : null,
          noOfDaysMailRepeated: formik.values.daysForEmail
            ? parseInt(formik.values.daysForEmail, 10)
            : null,
          enrollmentsByAgentInMinutes: formik.values.Enrollment
            ? parseInt(formik.values.Enrollment, 10)
            : null,
          maximumEnrollmentOfAgentInADay: formik.values.ExceededEnrollment
            ? parseInt(formik.values.ExceededEnrollment, 10)
            : null,
          emailScore: formik.values.emailScore
            ? parseInt(formik.values.emailScore)
            : null,
          emailVerdict: formik.values.emailRiskCategoryId || null,
          toEmailIds: emailIdsValue['emailIds'],
        }),
      });
      const data = await res.json();
      alert(data.message || JSON.stringify(data), 'success');
      setShowEmailModal(false)
      handleModalClose();
    } catch (error: any) {
      setShowEmailModal(false)
      console.error(error);
      alert('Something went wrong', 'error');
    } finally {
      setLoading(false);
    }
  };

  const isButtonDisabled = () => {
    const isEmpty = (value: any) =>
      value === "" ||
      value === null ||
      value === undefined ||
      value === "Select option"

    const allFields = integerFields.map(
      (field) => formik.getFieldMeta(field).value
    )

    const noValuesEntered = allFields.every((value) => isEmpty(value))

    const hasNegativeValue = allFields.some(
      (value) => !isEmpty(value) && parseInt(value, 10) < 0
    )

    const emailScoreValue = formik.getFieldMeta('emailScore').value === null;
    const emailScoreError = formik.errors.emailScore;

    if (!emailScoreValue && emailScoreError) return true; // Disable if email score is empty or has validation error
    return noValuesEntered || hasNegativeValue // Disable button if no values or any negative value
  }

  return createPortal(
    <>
      <Modal
        show={showEmailModal}
        onHide={() => setShowEmailModal(false)}
        dialogClassName='modal-dialog-centered'>
        <Modal.Header closeButton>
          <Modal.Title>Enter Email</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TextField
            fieldTitle={'Email IDs'}
            filedTitleMandatory={false}
            fieldName={'emailIds'}
            placeHolder={'e.g foo@example.com, joe@example.com'}
            handleOnChange={(e: any, name: string) => {
              formik.setFieldValue(name, e.target.value)
            }}
            formik={formik}
          />
        </Modal.Body>
        <Modal.Footer>
          <button onClick={sendEmail} className='btn btn-primary'
            data-bs-dismiss='modal' disabled={loading}>Send  {loading && <span className='spinner-border spinner-border-sm me-2' />}</button>
        </Modal.Footer>
      </Modal>

      <Modal
        id='kt_modal_create_app'
        tabIndex={-1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-650px'
        show={show}
        onHide={handleModalClose}
        backdrop={true}
      >
        <div className='modal-header'>
          <h4 className='modal-title'>Alerts</h4>
          <div
            className='btn btn-sm btn-icon btn-active-color-primary'
            onClick={() => handleModalClose()}
          >
            <img className='svg-icon-1' src={closeIcon} alt='close' />
          </div>
        </div>

        <div className='mh-450px overflow-auto modal-body mx-10 ps-8 pe-2'>
          <div className='modal-md'>
            <div className='modal-content'>
              <div className='modal-body pt-0'>
                {currentScreen === 'EMAILREPORT' && <EmailReport formik={formik} />}
                {currentScreen === 'QUICKDOWNLOAD' && (
                  <>
                    <form onSubmit={formik.handleSubmit}>
                      <Row className='d-flex align-items-end mt-5 no-gutters noPadding'>
                        <Col sm={12} md={12} className='pb-7'>
                          <TextField
                            fieldTitle={'Distance between Agent and Service Address'}
                            fieldType={'number'}
                            filedTitleMandatory={false}
                            fieldName={'DBtwAgentAndService'}
                            placeHolder={'Enter distance in feet'}
                            fieldValue={formik.getFieldMeta('DBtwAgentAndService').value}
                            handleOnChange={handleOnChange}
                            formik={formik}
                            className='noPadding'
                          />
                        </Col>
                        <Col sm={12} md={12} className='pb-7'>
                          <TextField
                            fieldTitle={'Distance between Agent and Customer'}
                            fieldType={'number'}
                            filedTitleMandatory={false}
                            fieldName={'DBtwAgentAndCustomer'}
                            placeHolder={'Enter distance in feet'}
                            fieldValue={formik.getFieldMeta('DBtwAgentAndCustomer').value}
                            handleOnChange={handleOnChange}
                            formik={formik}
                          />
                        </Col>
                        <Col sm={12} md={12} className='pb-7'>
                          <TextField
                            fieldTitle={'Phone numbers used in Enrollment more than once in'}
                            fieldTitleAfter={'of days'}
                            fieldType={'number'}
                            filedTitleMandatory={false}
                            fieldName={'daysForPhone'}
                            placeHolder={'Enter no. of days'}
                            fieldValue={formik.getFieldMeta('daysForPhone').value}
                            handleOnChange={handleOnChange}
                            formik={formik}
                          />
                        </Col>
                        <Col sm={12} md={12} className='pb-7'>
                          <TextField
                            fieldTitle={'Emails used in Enrollment more than once in '}
                            fieldTitleAfter={'of days'}
                            fieldType={'number'}
                            filedTitleMandatory={false}
                            fieldName={'daysForEmail'}
                            placeHolder={'Enter no. of days'}
                            fieldValue={formik.getFieldMeta('daysForEmail').value}
                            handleOnChange={handleOnChange}
                            formik={formik}
                          />
                        </Col>

                        <Col sm={12} md={12} className='pb-7'>
                          <TextField
                            fieldTitle={`No. of Enrollments within`}
                            fieldTitleAfter={'minutes by Agent on any day'}
                            fieldType={'number'}
                            filedTitleMandatory={false}
                            fieldName={'Enrollment'}
                            placeHolder={'Enter no. of minutes'}
                            fieldValue={formik.getFieldMeta('Enrollment').value}
                            handleOnChange={handleOnChange}
                            formik={formik}
                          />
                        </Col>
                        <Col sm={12} md={12}>
                          <TextField
                            fieldTitle={'No. of Enrollments exceeds'}
                            fieldTitleAfter={'by Agent on any day'}
                            fieldType={'number'}
                            filedTitleMandatory={false}
                            fieldName={'ExceededEnrollment'}
                            placeHolder={'Enter no. of enrollments'}
                            fieldValue={formik.getFieldMeta('Enrollment').value}
                            handleOnChange={handleOnChange}
                            formik={formik}
                          />
                        </Col>
                        {featureFlags?.getClientFeatureFlags?.enableLineTypeIntelligence && <>
                          <Col sm={12} md={12}>
                            <label className='d-flex align-items-center mb-2 mt-8'>
                              <span className='fs-6 fw-semibold lh-23px'>Email Risk Category</span>
                            </label>
                            <Dropdown
                              fieldName='emailRiskCategory'
                              optionList={emailOptions}
                              handleSelectedItem={handleSelectedItem}
                              formik={formik}

                            />
                          </Col>
                          <Col sm={12} md={12} className='pt-7'>
                            <TextField
                              fieldTitle={
                                <>
                                  Email Score
                                  <i
                                    className='bi bi-info-circle ms-2 text-primary cursor-pointer'
                                    onClick={() =>
                                      alert(
                                        'Alerts will include customers with email scores below this threshold. Lower scores represent higher risk.',
                                        'info'
                                      )
                                    }
                                  ></i>
                                </>
                              }
                              fieldType={'number'}
                              filedTitleMandatory={false}
                              fieldName={'emailScore'}
                              placeHolder={'Enter email score between 0-100'}
                              fieldValue={formik.getFieldMeta('emailScore').value}
                              handleOnChange={handleOnChange}
                              formik={formik}
                              className='noPadding'
                            />
                          </Col>
                        </>}
                      </Row>
                    </form>
                  </>
                )}
                {currentScreen === 'SCHEDULERECURRING' && (
                  <ScheduleRecurring
                    scheduleType={scheduleType}
                    setScheduleType={setScheduleType}
                    selectedDay={selectedDay}
                    setSelectedDay={setSelectedDay}
                    selectedDate={selectedDate}
                    setSelectedDate={setSelectedDate}
                    selectedTime={selectedTime}
                    setSelectedTime={setSelectedTime}
                    formik={formik}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <div className='modal-footer'>
          {currentScreen === 'QUICKDOWNLOAD' ? (
            <>
              <button
                type='button'
                className='btn btn-light'
                onClick={() => setCurrentScreen('SCHEDULERECURRING')}
                disabled={isButtonDisabled()}
              >
                Schedule download
              </button>
              <button
                className='btn btn-primary'
                data-bs-dismiss='modal'
                onClick={gettingEmailId}
                disabled={isButtonDisabled()}
              >
                Quick download
              </button>
            </>
          ) : (
            <>

              <button type='button' className='btn btn-light' onClick={() => handleBackScreen()}>
                Back
              </button>
              <button
                className='btn btn-primary'
                onClick={() => {
                  currentScreen === 'EMAILREPORT'
                    ? formik.errors && formik.submitForm()
                    : handleScheduleApi()
                }}
                data-bs-dismiss='modal'
              >
                {currentScreen === 'EMAILREPORT' ? 'Send' : 'Save'}
              </button>
            </>
          )}
        </div>
      </Modal >
    </>,

    modalsRoot
  )
}

export { AlertReportModaal }
